module.exports = __webpack_public_path__ + "img/local.5596813f.png";